import React from 'react';
import classNames from 'classnames';
import { Select } from 'antd';
import { SourcingHomeTab, SourcingMarketplaceSearchType } from '@/shared/types/sourcing-marketplace';
import { logCommonView } from '@/lib/service';
import { EventSource } from '@/shared/constants/event';
import { HOMEPAGE_TABS, HOMEPAGE_TAB_TO_TEXT } from '@/shared/constants/sourcing-marketplace';
import RequestRFPButton from '../../Common/RequestRFPButton';
import SourcingMarketplaceSearch from '../../Common/SourcingMarketplaceSearch';
import { map } from 'lodash-es';
import './index.less';

interface IProps {
  selectedTab: SourcingHomeTab;
  toggleTab: (tab: SourcingHomeTab) => void;
}

const SourcingTabSelector = ({ selectedTab, toggleTab }: IProps) => {
  const rfpButton = <RequestRFPButton eventContent="homepage" />;

  const logTabClick = (eventContent: string) => {
    logCommonView(EventSource.HOME_FIND_SUPPLIER, eventContent);
  };

  const mobileTabSelector = (
    <Select
      className="mobile-select"
      value={selectedTab}
      onChange={(tabValue) => {
        logTabClick(tabValue.toLowerCase());
        toggleTab(tabValue);
      }}
      options={HOMEPAGE_TABS.map((tab) => {
        if (tab.label === SourcingHomeTab.ALL) {
          return {
            label: <span className="sourcing-tab-mobile-option-text">All factories, freelancers, and agencies</span>,
            value: tab.value,
          };
        } else {
          return {
            label: <span className="sourcing-tab-mobile-option-text">{HOMEPAGE_TAB_TO_TEXT[tab.label]}</span>,
            value: tab.value,
          };
        }
      })}
      aria-label="mobile selector for sourcing categories"
    />
  );

  const desktopTabSelector = (
    <div className="desktop-selector">
      {map(HOMEPAGE_TABS, (tab: any) => {
        return (
          <div
            className={classNames('option', {
              selected: selectedTab === tab.value,
            })}
            onClick={() => {
              logTabClick(tab.value.toLowerCase());
              toggleTab(tab.value);
            }}
            key={tab.label}
            id={tab.id}
          >
            <span>{HOMEPAGE_TAB_TO_TEXT[tab.label]}</span>
          </div>
        );
      })}
    </div>
  );

  const marketplaceSearch = (
    <SourcingMarketplaceSearch
      searchType={SourcingMarketplaceSearchType.HOMEPAGE}
      topRankedSearchTerms={[]}
      placeholderText="Search suppliers, products, and services"
    />
  );

  return (
    <div className="tab-selector-container">
      <div className="top">
        <div className="top-content">
          <div className="title-container">
            <h1 className="title">Sourcing</h1>
            {marketplaceSearch}
            {rfpButton}
          </div>
          {marketplaceSearch}

          <div className="desktop-tab-selector-container">
            {desktopTabSelector}
            {rfpButton}
          </div>

          <div className="mobile-tab-selector-container">{mobileTabSelector}</div>
        </div>
      </div>
    </div>
  );
};

export default SourcingTabSelector;
